import React, { useMemo } from 'react';
import useFirestore from '../../hooks/useFirestore';
import Chart from '../../components/Chart/Chart';
import styles from './Overview.module.css';

export default function Overview() {
  const { data: products, loading: loadingProducts } = useFirestore('products');
  const { data: orders, loading: loadingOrders } = useFirestore('orders');
  const { data: customers, loading: loadingCustomers } = useFirestore('customers');

  const loading = loadingProducts || loadingOrders || loadingCustomers;

  const totalRevenue = useMemo(
    () => orders.reduce((sum, o) => sum + (Number(o.total) || 0), 0),
    [orders]
  );

  const stats = [
    {
      label: 'إجمالي الإيرادات',
      value: `${totalRevenue.toLocaleString('en-US')} ج.م`,
      trend: '+12.4%',
      up: true,
      icon: '💰',
    },
    {
      label: 'عدد الطلبات',
      value: orders.length,
      trend: '+5.1%',
      up: true,
      icon: '📦',
    },
    {
      label: 'عدد المنتجات',
      value: products.length,
      trend: '+2.0%',
      up: true,
      icon: '🛍️',
    },
    {
      label: 'عدد العملاء',
      value: customers.length,
      trend: '-1.3%',
      up: false,
      icon: '👥',
    },
  ];

  // بيانات الإيرادات مجمّعة حسب اليوم (لآخر الطلبات) - رسم Area
  const revenueTrend = useMemo(() => {
    const map = {};
    orders.forEach((o) => {
      const date = o.createdAt?.toDate ? o.createdAt.toDate() : new Date();
      const key = date.toLocaleDateString('ar-EG', { day: '2-digit', month: '2-digit' });
      map[key] = (map[key] || 0) + (Number(o.total) || 0);
    });
    return Object.entries(map)
      .slice(-7)
      .map(([name, value]) => ({ name, value }));
  }, [orders]);

  // توزيع حالات الطلبات - رسم Pie
  const statusBreakdown = useMemo(() => {
    const map = {};
    orders.forEach((o) => {
      const status = o.status || 'قيد الانتظار';
      map[status] = (map[status] || 0) + 1;
    });
    return Object.entries(map).map(([name, value]) => ({ name, value }));
  }, [orders]);

  return (
    <div className={styles.page}>
      <div className={styles.header}>
        <h2>نظرة عامة</h2>
        <p>ملخص أداء متجرك اليوم</p>
      </div>

      <div className={styles.statsGrid}>
        {stats.map((s) => (
          <div key={s.label} className={styles.statCard}>
            <div className={styles.statTop}>
              <div className={styles.iconBox}>{s.icon}</div>
              <span className={`${styles.trend} ${s.up ? styles.trendUp : styles.trendDown}`}>
                {s.trend}
              </span>
            </div>
            <p className={styles.statLabel}>{s.label}</p>
            <p className={`${styles.statValue} nums`}>{loading ? '—' : s.value}</p>
          </div>
        ))}
      </div>

      <div className={styles.chartsGrid}>
        <div className={styles.chartCard}>
          <h3>اتجاه الإيرادات (آخر 7 أيام)</h3>
          <Chart type="area" data={revenueTrend} />
        </div>
        <div className={styles.chartCard}>
          <h3>حالة الطلبات</h3>
          <Chart type="pie" data={statusBreakdown} />
        </div>
      </div>
    </div>
  );
}
